import CandidateListItem from './CandidateListItem';
export default CandidateListItem
